import React from 'react';
import { RadioGroup, RadioGroupItem } from '@radix-ui/react-radio-group';

import { cn } from '@epoch-ui/lib/utils';
import {
  ActionButton,
  ActionButtonIcon,
  ActionButtonLabel,
  ActionButtonCaption
} from '@epoch-ui/components/ActionButton';

export const ActionButtonGroup = React.forwardRef<
  React.ElementRef<typeof RadioGroup>,
  React.ComponentProps<typeof RadioGroup>
>(({ className, ...props }, ref) => {
  return (
    <RadioGroup className={cn('tw-flex tw-flex-col tw-gap-3', className)} {...props} ref={ref} />
  );
});

export const ActionButtonGroupItem = React.forwardRef<
  React.ElementRef<typeof RadioGroupItem>,
  React.ComponentProps<typeof RadioGroupItem>
>(({ className, children, ...props }, ref) => {
  return (
    <RadioGroupItem
      asChild
      className={cn(
        'tw-group data-[state=checked]:tw-border-2 data-[state=checked]:tw-border-primary-blue',
        className
      )}
      {...props}
      ref={ref}
    >
      <ActionButton>{children}</ActionButton>
    </RadioGroupItem>
  );
});

export const ActionButtonGroupItemIcon = React.forwardRef<
  React.ElementRef<typeof ActionButtonIcon>,
  React.ComponentProps<typeof ActionButtonIcon>
>(({ className, ...props }, ref) => {
  return (
    <ActionButtonIcon
      className={cn(
        'tw-bg-secondary tw-text-secondary-foreground group-data-[state=checked]:tw-bg-brand-tertiary group-data-[state=checked]:tw-text-primary-blue',
        className
      )}
      {...props}
      ref={ref}
    />
  );
});

export const ActionButtonGroupItemLabel = ActionButtonLabel;

export const ActionButtonGroupItemCaption = ActionButtonCaption;
